import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-server-benchmark'

const headers = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  'Authorization': token
})

export const fetchServerBenchmark = async (token) => {
  const response = await axios.get(`${host}/${PLUGINS_NAME}/snapshot`, {
    headers: headers(token)
  })
  if (response && response.status === 200) {
    return response.data
  }
  return null
}

/** POST /admin-system/restart-forever-shell — scope: 'api' | 'all', restartPassword required */
export const restartForeverShell = async (token, scope, restartPassword) => {
  const response = await axios.post(
    `${host}/admin-system/restart-forever-shell`,
    { scope, restartPassword },
    { headers: headers(token), timeout: 30000 }
  )
  if (response && response.status === 200) {
    return response.data
  }
  return null
}
